import React from "react";

import { useTranslation } from "react-i18next";

import { RecentFormStandings } from "@data-types/sport-stats/SportStatsTypes";

export const TeamStandingsLastFiveForm = ({
	recentForm,
}: {
	recentForm?: RecentFormStandings[];
}) => {
	const shortOutcomes = recentForm?.map(
		(form: RecentFormStandings) => form?.shortOutcome
	);
	const longOutcomes = recentForm?.map(
		(form: RecentFormStandings) => form?.longOutcome
	);
	const { t } = useTranslation();

	if (!shortOutcomes) {
		return (
			<div className="stats--scores">
				<div className="stats--scores__box"></div>
				<div className="stats--scores__box"></div>
				<div className="stats--scores__box"></div>
				<div className="stats--scores__box"></div>
				<div className="stats--scores__box"></div>
			</div>
		);
	}

	return (
		<div className="stats--scores">
			{Array.from({ length: 5 }).map((_, index) => (
				<TeamStandingsEventForm
					key={index}
					shortOutcome={shortOutcomes?.[index]}
					tooltip={
						longOutcomes?.[index]
							? longOutcomes[index]
							: t("EVENT.STATISTICS.TEAM_STANDINGS.NO_DATA")
					}
					index={index}
				/>
			))}
		</div>
	);
};
const TeamStandingsEventForm = ({
	shortOutcome,
	tooltip,
	index,
}: {
	shortOutcome?: RecentFormStandings["shortOutcome"];
	tooltip?: RecentFormStandings["longOutcome"];
	index: number;
}) => {
	const tooltipId = `tooltip-${index}`;

	return (
		<>
			<div
				className={`stats--scores__box stats--scores__box--${classMap[shortOutcome as keyof typeof classMap] || "none"}`}
				data-tooltip-id={tooltipId}
				data-tooltip-content={tooltip}
				title={tooltip}
			>
				{shortOutcome}
			</div>
		</>
	);
};

const classMap: Record<RecentFormStandings["shortOutcome"], string> = {
	W: "win",
	L: "lose",
	D: "draw",
};
